import { useParams, useNavigate } from 'react-router-dom';

import RegisterHeader from '../../components/common/register/RegisterHeader';
import EmailIcon from '../../assets/images/email.svg';

export default function ConfirmEmail() {
  const navigate = useNavigate();
  const { email } = useParams(); // gets the dynamic segment from the URL

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#E7EFFF]">
      <div className="z-10 w-full lg:w-[1044px] bg-white rounded-[20px] shadow-xl ">
        {/* Top header */}
        <RegisterHeader currentStep={1} onClose={() => navigate('/')} />

        {/* Body */}
        <div className="relative w-full py-8 md:py-12 px-8 md:px-20 lg:px-52 space-y-8 bg-[#F9F9F9] rounded-b-[0px] lg:rounded-b-[20px]">
          <div className="space-y-10">
            <div className="sm:px-15 py-10 sm:py-18 space-y-3">
              <div className="w-full flex items-center justify-center">
                <div
                  style={{
                    background:
                      'radial-gradient(circle, #ACC8FF 0%, #4381FF 100%)',
                  }}
                  className="opacity-70 w-[138px] h-[138px] px-[26px] py-[41px] rounded-full flex items-center justify-center"
                >
                  <img
                    src={EmailIcon}
                    alt="Email Icon"
                    className="w-[85px] h-[54px] text-blue-600"
                  />
                </div>
              </div>

              <div className="space-y-2 text-center">
                <div className="w-full h-10 flex items-center justify-center">
                  <p className="font-[poppins] text-xl font-[#252B37] font-semibold leading-[20px] tracking-[0%]">
                    Verifica tu correo electrónico
                  </p>
                </div>
                <div className="space-y-1">
                  <p className="py-2 font-[poppins] text-base font-medium font-[#414651] leading-[20px] tracking-[0%]">
                    {`Hemos enviado un email a ${email}. Por favor, verifica
                    tu cuenta para continuar con el registro.`}
                  </p>
                  <p className="font-[poppins] text-base font-normal leading-[20px] tracking-[0%] font-[#535862]">
                    Si no encuentras el correo, revisa la bandeja de spam o
                    correo no deseado.
                  </p>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="font-[poppins] text-xs text-gray-600 font-semibold leading-[20px] tracking-[0%]">
              ¿Necesitas ayuda?{' '}
              <a href="#" className="font-[500] text-[#092F7B]">
                Contactar a soporte
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
